import { Injectable } from '@angular/core';
import { SimpleConfigBaseFilter } from 'gung-list';
import { Product } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class ProductShelfManufacturerFilterService extends SimpleConfigBaseFilter<Product> {
  getName(): string {
    return 'SHELF_MANUFACTURER';
  }
  getOptionIds(item: Product): string[] {
    return item.extra.hlPimProduct.ShelfManufacturer || [];
  }
  getOptionName(key: string): string {
    return key;
  }
}
